import React, { useState, useEffect } from "react";
import "./style.css";
import Pageloader from "../../components/loader";
import {
  Table,
  Typography,
  Button,
  Menu,
  Input,
  DatePicker,
  Dropdown,
  Modal,
  Select,
  Space,
} from "antd";
import moment from "moment";
import { MoreOutlined, PlusOutlined } from "@ant-design/icons";
import { userhasPermissionHelper, validationErrors } from "../../utils/Helpers";
import { useNavigate } from "react-router-dom";

import * as shiftActions from "../../redux/actions/shift.actions";
import * as zoneActions from "../../redux/actions/zone.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { PERMISSION_CONSTANT } from "../../utils/constants/app";

const { RangePicker } = DatePicker;
const { Search } = Input;
const { Link, Title, Text } = Typography;
const { Option } = Select;

const Shift = (props) => {
  const navigate = useNavigate();

  const pagename = "Shift";
  const [postData, setPostData] = useState(null);
  const [loading, setLoading] = useState(false);
  // const [isDisabled, setIsDisabled] = useState(false);
  const [postDataZone, setPostDataZone] = useState(null);
  const [totalPages, setTotalPages] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageSize, setCurrentPageSize] = useState(10);
  const [totalShiftsCount, setTotalShiftCount] = useState(null);

  useEffect(() => {
    postLists();
    // globalSearch("", "", "", "", "", currentPage, currentPageSize);
  }, []);

  useEffect(() => {
    setPostData(props.shiftData);
  }, [props.shiftData]);
  useEffect(() => {
    setTotalPages(props.shiftPagination.totalCount);
    setCurrentPageSize(props.shiftPagination.limit);
    setCurrentPage(props.shiftPagination.currentPage);
    setTotalShiftCount(props.shiftPagination.totalShiftsCount);
  }, [props.shiftPagination]);

  useEffect(() => {
    setPostDataZone(props.zoneData);
  }, [props.zoneData]);

  const postLists = async (show_loder = true, call_zone = true) => {
    try {
      const data = {
        page: currentPage,
        limit: currentPageSize,
      };
      if (show_loder) setLoading(true);
      await props.shiftActions.getShiftsFiltersPaginationAction(data);
      if (call_zone) await props.zoneActions.getZoneListAction();
    } catch (error) {
      validationErrors(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClick = async (id, type) => {
    if (type === "active") {
      const shift_id = { shiftId: id };
      try {
        await props.shiftActions.shiftActiveAction(shift_id);
        postLists(false, false);
        // swalNotification("Shift Activate", resp.data.message, "success");
      } catch (error) {
        validationErrors(error);
      }
    }
    if (type === "inactive") {
      const shift_id = { shiftId: id };
      try {
        await props.shiftActions.shiftInActiveAction(shift_id);
        postLists(false, false);
        // swalNotification("Shift Inactive", resp.data.message, "success");
      } catch (error) {
        validationErrors(error);
      }
    }
  };

  const actions = (shiftId, shiftDisplayId, shiftStatus) => {
    const handlePressOk = async (shiftId, status) => {
      // setIsDisabled(true);
      await handleClick(shiftId, status);
    };
    return (
      <Menu
        items={[
          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.EDIT_SHIFTS) &&
          (shiftStatus === true ? 
            ""
            : 
            {
              key: "1",
              label: (
                <a
                  onClick={() => navigate(`/shifts/shiftEdit/${shiftId}`)}
                  disabled={shiftStatus === true ? true : false}
                  style={{
                    pointerEvents: shiftStatus === true ? "none" : "auto",
                  }}
                >
                  Edit {pagename}
                </a>
              ),
            }
          ),
          // {
          //   key: "2",
          //   label: <a href={`/rider/${riderId}`}>View {pagename}</a>,
          // },
          // {
          //   key: "2",
          //   label: <a onClick={() => AssignBatchModal()}>Assign Batch</a>,
          // },
          // {
          //   key: "3",
          //   label: <a onClick={() => AssignZoneModal()}>Assign Zone</a>,
          // },
          
          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_SHIFT_ACTIVE) &&
          (shiftStatus === true ? 
            ""
            : 
            {
              key: "2",
              label: (
                <div
                  style={{
                    pointerEvents: shiftStatus === "false" ? "none" : "auto",
                  }}
                >
                  <span
                    onClick={() =>
                      Modal.confirm({
                        content:
                          "Are you sure you want to activate " +
                          shiftDisplayId +
                          " shift?",
                        centered: true,
                        maskClosable: true,
                        onOk: async () =>
                          await handlePressOk(shiftId, "active"),
                      })
                    }
                    // disabled={riderStatus === "approved" ? true : false}
                  >
                    {shiftStatus === false ? "Active" : ""}
                  </span>
                </div>
              ),
            }
          ),
          userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_SHIFT_INACTIVE) &&
          (shiftStatus === false ? 
            ""
            : 
            {
              key: "3",
              label: (
                <div
                  style={{
                    pointerEvents: shiftStatus === "false" ? "none" : "auto",
                  }}
                >
                  <span
                    onClick={() =>
                      Modal.confirm({
                        content:
                          "Are you sure you want to deactivate " +
                          shiftDisplayId +
                          " shift?",
                        centered: true,
                        maskClosable: true,
                        onOk: async () =>
                          await handlePressOk(shiftId, "inactive"),
                      })
                    }
                    // disabled={riderStatus === "approved" ? true : false}
                  >
                    {shiftStatus === true ? "Inactive" : ""}
                  </span>
                </div>
              ),
            }
          ),
        ]}
      />
    );
  };

  let currentDateTimeStamp = moment().format("X");

  const postColumns = [
    {
      title: "Shift ID",
      dataIndex: "display_id",
      key: "display_id",
      sorter: (record1, record2) => {
        return record1.display_id > record2.display_id;
      },
    },
    {
      title: "Zone",
      dataIndex: "zone",
      key: "zone",
      render: (zone) => (zone ? <Text>{zone.zoneName}</Text> : ""),
    },
    {
      title: "Start Date Time",
      render: (proId) => {
        const STview = moment
          .unix(proId.startTime)
          .format("DD MMMM, yyyy, h:mm A");
        return STview;
      },
    },
    {
      title: "End Date Time",
      render: (proId) => {
        const ETview = moment
          .unix(proId.endTime)
          .format("DD MMMM, yyyy, h:mm A");
        return ETview;
      },
    },
    {
      title: "Slots",
      dataIndex: "totalSlots",
      key: "totalSlots",
    },
    {
      title: "Slots Filled",
      dataIndex: "totalSlotsFilled",
      key: "totalSlotsFilled",
    },
    {
      title: "Status",
      render: (record) => {
        return (record.isActive === false || record.isActive === true) &&
          currentDateTimeStamp >= Number(record.startTime) &&
          currentDateTimeStamp >= Number(record.endTime) ? (
          <Text style={{ color: "lightgrey" }}>Expired</Text>
        ) : currentDateTimeStamp >= Number(record.startTime) &&
          currentDateTimeStamp <= Number(record.endTime) &&
          record.isActive === true ? (
          <Text type="success">Started</Text>
        ) : record.isActive === true ? (
          <Text type="warning">Active</Text>
        ) : (
          <Text type="danger">Inactive</Text>
        );
      },
      // dataIndex: "isActive",
    },
    {
      title: "Action",
      render: (record) => {
        return (
          <Dropdown
            disabled={
              currentDateTimeStamp >=
              Number(record.shiftDuration * 3600) + Number(record.startTime)
                ? true
                : false
            }
            overlay={() =>
              actions(record.id, record.display_id, record.isActive)
            }
            onClick={(e) => {
              // console.log(
              //   "corresponding id and status is :",
              //   record._id + " " + record.isActive
              // );
            }}
          >
            <Link
              // href="#"
              type={[
                record.status === "active"
                  ? "success"
                  : record.status === "inactive"
                  ? "danger"
                  : "",
              ]}
            >
              <Button
                disabled={
                  currentDateTimeStamp >=
                  Number(record.shiftDuration * 3600) + Number(record.startTime)
                    ? true
                    : false
                }
              >
                <MoreOutlined />
              </Button>
            </Link>
          </Dropdown>
        );
      },
      onCell: (record, rowIndex) => {
        return {
          onClick: (e) => {
            e.stopPropagation();
          },
        };
      },
    },
  ];

  const menu = (
    <Menu
      items={[
        {
          key: "1",
          label: (
            <span onClick={() => navigate("/shifts/shiftbulk")}>
              Bulk Shift Add
            </span>
          ),
        },
        {
          key: "2",
          label: (
            <span onClick={() => navigate("/shifts/riderShiftbulkAssignment")}>
              Bulk Assign Rider Shift
            </span>
          ),
        },
      ]}
    />
  );

  let start_date = "";
  let end_date = "";
  const [filter, setFilter] = useState("");
  const [status, setStatus] = useState("");
  const [zone, setZone] = useState("");
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  let zoneValue = "";
  let statusValue = "";
  let searchValue = "";

  const handleChange = (props) => {
    if (props) {
      const [start, end] = props;
      setStartDate(start);
      setEndDate(end);
      statusValue = status !== "" ? status : "";
      zoneValue = zone !== "" ? zone : "";
      searchValue = filter === "display_id" ? search : "";
      globalSearch(
        searchValue,
        statusValue,
        zoneValue,
        start,
        end,
        currentPage,
        currentPageSize
      );
    } else {
      setStartDate(null);
      setEndDate(null);
      statusValue = status !== "" ? status : "";
      zoneValue = zone !== "" ? zone : "";
      searchValue = filter === "display_id" ? search : "";
      globalSearch(
        searchValue,
        statusValue,
        zoneValue,
        "",
        "",
        currentPage,
        currentPageSize
      );
    }
  };

  const setFiltervalue = (value) => {
    setFilter(value);
    if (value === "all") {
      setZone("");
      setStatus("");
      globalSearch("", "", "", "", "", currentPage, currentPageSize);
    }
  };

  const setStatusValue = (value) => {
    setStatus(value);
    searchValue = "";
    statusValue = value;
    zoneValue = zone !== "" ? zone : "";
    start_date = startDate === null ? "" : startDate;
    end_date = endDate === null ? "" : endDate;
    globalSearch(
      searchValue,
      statusValue,
      zoneValue,
      start_date,
      end_date,
      page,
      pageSize
    );
  };

  const setZoneValue = (value) => {
    setZone(value);
    zoneValue = value;
    statusValue = status !== "" ? status : "";
    start_date = startDate === null ? "" : startDate;
    end_date = endDate === null ? "" : endDate;
    globalSearch(
      searchValue,
      statusValue,
      zoneValue,
      start_date,
      end_date,
      page,
      pageSize
    );
  };

  const filtersWithPagination = async (data) => {
    try {
      setLoading(true);
      await props.shiftActions.getShiftsFiltersPaginationAction(data);
    } catch (error) {
      validationErrors(error);
    } finally {
      setLoading(false);
    }
  };

  const [page] = useState(1);
  const [pageSize] = useState(10);

  const pageChange = (page, pageSize) => {
    zoneValue = zone !== "" ? zone : "";
    statusValue = status !== "" ? status : "";
    start_date = startDate === null ? "" : startDate;
    end_date = endDate === null ? "" : endDate;
    globalSearch(
      searchValue,
      statusValue,
      zoneValue,
      start_date,
      end_date,
      page,
      pageSize
    );
  };

  const globalSearch = (
    search,
    status,
    zone,
    start_date,
    end_date,
    currentPage = 1,
    currentPageSize = 10
  ) => {
    const data = {
      keyword: filter === "display_id" ? "" : search,
      display_id: search !== "" ? search : "",
      // zone: filter == "zone" ? zone : "",
      // status: filter == "status" ? status : "",
      zone: filter === "display_id" ? "" : zone !== "" ? zone : "",
      status: filter === "display_id" ? "" : status !== "" ? status : "",
      startDate:
        start_date === "" || start_date === null
          ? ""
          : filter === "display_id"
          ? ""
          : moment(start_date).startOf('day').toISOString(),
      endDate:
        end_date === "" || end_date === null
          ? ""
          : filter === "display_id"
          ? ""
          : moment(end_date).endOf('day').toISOString(),
      page: currentPage,
      // limit: currentPageSize,
      limit:
        filter === "display_id"
          ? currentPageSize
          : zone !== ""
          ? currentPageSize
          : currentPageSize,
    };

    filtersWithPagination(data);
    return postData;
  };

  return (
    <div className="page-content">
      <div className="page-content-header">
        <div className="pch">
          <Title level={2}>{pagename}s Management</Title>
        </div>
        <div className="pch">
          <Space direction="horizontal">
            {userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_SHIFT_UPLOAD_CSV) &&
              <Dropdown overlay={menu} placement="bottom">
                <Button>
                  Upload CSV <PlusOutlined />
                </Button>
              </Dropdown>
            }
            {userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.CREATE_SHIFTS) &&
              <Button onClick={() => navigate("/shifts/shiftcreate")}>
                Create {pagename}
              </Button>
            }
          </Space>
        </div>
      </div>
      <div className="p-content">
        <div className="page-content-header">
          <div className="pch"></div>
          <div className="pch">
            <Space direction="horizontal">
              <Select
                value={filter}
                disabled={loading}
                onChange={setFiltervalue}
                style={{
                  width: 120,
                }}
              >
                <Option value="all">All</Option>
                <Option value="display_id">Shift ID</Option>
                <Option value="zone">Zone</Option>
                {/* <Option value="status">Status</Option> */}
              </Select>
              {filter === "zone" || filter === "status" ? (
                <Select
                  value={zone}
                  onChange={setZoneValue}
                  disabled={loading}
                  placeholder="Select Zone"
                  style={{ width: "300px" }}
                >
                  <Option value="">Select Zone</Option>
                  {postDataZone &&
                    postDataZone.map((zone) => (
                      <Select.Option key={zone.zoneName} value={zone.id}>
                        {zone.zoneName}
                      </Select.Option>
                    ))}
                </Select>
              ) : (
                ""
              )}
              {filter === "status" || filter === "zone" ? (
                <Select
                  value={status}
                  onChange={setStatusValue}
                  disabled={loading}
                  style={{
                    width: 120,
                  }}
                >
                  <Option value="">Select Status</Option>
                  <Option value="active">Active</Option>
                  <Option value="inactive">Inactive</Option>
                  <Option value="started">Started</Option>
                  <Option value="expired">Expired</Option>
                  {/* <Option value="blocked">Blocked</Option> */}
                  {/* })} */}
                </Select>
              ) : (
                ""
              )}
              {filter === "display_id" ? (
                <Search
                  placeholder=""
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onSearch={globalSearch}
                  disabled={loading}
                />
              ) : (
                ""
              )}
              {filter === "zone" || filter === "status" ? (
                <RangePicker
                  // showTime
                  format="YYYY-MM-DD"
                  value={[startDate, endDate]}
                  onChange={handleChange}
                  disabled={loading}
                />
              ) : (
                ""
              )}
            </Space>
          </div>
        </div>
        {loading ? (
          <Pageloader />
        ) : (
          <Table
            className="tablehover"
            dataSource={postData}
            columns={postColumns}
            onRow={(r, i) => ({
              // onClick: (e) => navigate(`/shifts/shiftView/${r.id}`),
              onDoubleClick: (e) => window.open(`/shifts/shiftView/${r.id}`),
            })}
            pagination={{
              current: currentPage,
              pageSize: currentPageSize,
              pageSizeOptions: ["10", "20", "30", "40", "50"],
              showSizeChanger: true,
              total: totalPages, // total count returned from backend
              onChange: (page, pageSize) => {
                pageChange(page, pageSize);
              },
            }}
          />
        )}
        {/* {postData && (
          <Table
            className="tablehover"
            dataSource={postData}
            columns={postColumns}
            // onChange={handleChange}
            onRow={(r, i) => ({
              // onClick: (e) => navigate(`/shifts/shiftView/${r.id}`),
              onDoubleClick: (e) => window.open(`/shifts/shiftView/${r.id}`),
            })}
            // showSizeChanger
            // pageSizeOptions={[10, 20, 30, 40, 50]}
            pagination={{
              current: currentPage,
              pageSize: currentPageSize,
              pageSizeOptions: ["10", "20", "30", "40", "50"],
              showSizeChanger: true,
              total: totalPages, // total count returned from backend
              onChange: (page, pageSize) => {
                // console.log("page size ", pageSize);
                pageChange(page, pageSize);
              },
            }}
          />
        )} */}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    shiftData: state.ShiftReducer.shiftData,
    shiftPagination: state.ShiftReducer.shiftPagination,
    zoneData: state.ZoneReducer.zoneData,
    permissions: state.PermissionReducer.permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    shiftActions: bindActionCreators(shiftActions, dispatch),
    zoneActions: bindActionCreators(zoneActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Shift);
